import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./table.css";

export default function BTable({ rows, data, cellStyles = {},className }) {
  const formatDateRange = (dateRange) => {
    if (!dateRange) return [""]; 

    const parts = dateRange.split(" to ");
    if (parts.length < 2) return [dateRange];  

    return [parts[0].trim(), "to", parts[1].trim()];  
  };
  return (
     <TableContainer component={Paper} className={`table_des ${className}`} >
      <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {rows?.map((row) => (
              <TableCell className="head" key={row.field}>
                {row.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.length > 0 ? (
            data?.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {rows.map((column) => (
                  <TableCell
                    key={column.field}
                    sx={{
                      whiteSpace: column.field === "scheduleDateTime" ? "pre-wrap" : "normal",  
                      ...(column.field === "status" ? cellStyles[row[column.field]?.toLowerCase()] || {} : {}),
                    }}
                  >
                   {column.field === "scheduleDateTime"
                      ? formatDateRange(row[column.field]).map((line, idx) => (
                        <div key={idx} style={{ textAlign: "center" }}>
                          {line}
                        </div>
                      ))
                      : row[column.field]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>No Data Found</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
   );
}
